<template>
  <div v-if="wrapshow">
    <!-- :style="{ height: '80%' }" -->
    <van-popup v-model="open" position="bottom" @closed="wrapshow = false">
      <van-datetime-picker
        v-model="value"
        v-bind="attrs"
        :formatter="formatter"
        @confirm="confirm"
        @cancel="close"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wrapshow: true,
      open: false,
      value: "",
      attrs: {},
    };
  },
  created() {},
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      } else if (type === 'hour') {
        return `${val}时`;
      } else if (type === 'minute') {
        return `${val}分`;
      }
      return val;
    },
    showPicker(opts = {}) {
      return new Promise((resolve) => {
        this.wrapshow = true;
        this.open = true;
        this.value = opts.value
        delete opts.value
        this.attrs = opts
        this._resolve = resolve;
      });
    },
    close(e) {
      this.open = false;
    },
    confirm(e) {
      this.close();
      this._resolve(e);
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped></style>
